import React from "react";
import { withRouter } from "../../utils/tms-with-router/tms-with-router";
const TmsOrders = () => {
  return <div>Hello, Welcome to Devasthanam Orders</div>;
};
export default withRouter(TmsOrders);
